"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = exports.StyledHeading = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var StyledHeading = (0, _theming.styled)("h2", process.env.NODE_ENV === "production" ? {
  target: "e1dfl2uu0"
} : {
  target: "e1dfl2uu0",
  label: "StyledHeading"
})("color:", _styles.color.darkest, ";font-size:", _styles.typography.size.m3, "px;font-weight:", _styles.typography.weight.black, ";letter-spacing:-0.29px;line-height:", _styles.typography.size.l2, "px;margin-bottom:4px;@media (min-width: ", _styles.breakpoint * 1, "px){font-size:36px;margin-bottom:8px;letter-spacing:-0.37px;}");
exports.StyledHeading = StyledHeading;

var Heading = function Heading(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledHeading, props);
};

exports.Heading = Heading;